module.exports = __webpack_public_path__ + "media/images/bsmart-bottom-cfaa4a0a097a85e5f13f626a32e36c7f.png";